import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import TopBar from './components/TopBar';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AccessibilityWidget from './components/AccessibilityWidget';
import Home from './pages/Home';
import DogsForAdoption from './pages/DogsForAdoption';
import AboutShelter from './pages/AboutShelter';
import Support from './pages/Support';
import Contact from './pages/Contact';
import DogDetail from './pages/DogDetail';
import Przetargi from './pages/Przetargi';
import NotFound from './pages/NotFound';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-shell">
        <TopBar />
        <Navbar />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dogs" element={<DogsForAdoption />} />
            <Route path="/dogs/:id" element={<DogDetail />} />
            <Route path="/about" element={<AboutShelter />} />
            <Route path="/support" element={<Support />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/przetargi" element={<Przetargi />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <AccessibilityWidget />
      </div>
    </Router>
  );
}

export default App;
